import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import APICaller, { MethodType } from '../common/APICaller';
import JobStatusCard, { JobStatusCardProps } from './JobStatusCard';
import CustomizedModal from '../common/CustomizedModal';
import { useNavigate } from 'react-router-dom';
import { useLoading } from '../../contexts/LoadingContext';

const errorMessages = [
  "Please create your profile first",
  "You don't have any applications right now."
]

const buttonTexts = [
  "Create My Profile",
  "View Jobs"
]

const ApplicationStatusCards: React.FC = () => {
  const [applications, setApplications] = useState<JobStatusCardProps[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>(errorMessages[0]);
  const [modalButtonText, setModalButtonText] = useState<string>(buttonTexts[0]);
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        showLoading('Loading your applications...');
        const res = await APICaller('/application', MethodType.GET);
        if (res.errorMessage) {
          setErrMsg(errorMessages[0]);
          setModalButtonText(buttonTexts[0]);
          setOpenModal(true);
        } else {
          setApplications(res);
          if (res.length === 0) {
            setOpenModal(true);
            setErrMsg(errorMessages[1]);
            setModalButtonText(buttonTexts[1]);
          }
        }
      } catch (error) {
        console.error('Error loading applications:', error);
      } finally {
        hideLoading();
      }
    };

    fetchApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box sx={{ maxWidth: '950px', margin: '0 auto' }}>
        <Grid container direction="column">
          {applications.map(data => (
            <Grid item xs={12} key={data.id}>
              <JobStatusCard
                id={data.id}
                title={data.title}
                applicationStatus={data.applicationStatus}
                country={data.country}
                province={data.province}
                city={data.city}
                currentlyAvailable={data.currentlyAvailable}
                submittedAt={data.submittedAt}
                remote={data.remote}
                jobType={data.jobType}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <CustomizedModal
        open={openModal}
        clickHandler={() => {
          if (applications.length === 0) {
            navigate('/jobs');
          } else {
            navigate('/profile');
          }
        }}
        title="Oops!"
        description={errMsg}
        buttonText={modalButtonText}
      />
    </>
  );
};

export default ApplicationStatusCards;
